import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';

//Services
import { getAllDetails, postAllData } from '../../../service/ProductService';

// Data table
import { defaultRowOptions, Skeletonitems, SkeletonbodyTemplate } from '../../../appconfig/Settings';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

import { APPROVEFRSHALLAPP, DOCUMENTLIST, FILEDETAIL, UPLOADDOCUMENT, VERIFYDOCUMENT } from '../../../config/ApiConstant';
import { formatDateTime, setAppStatus } from '../../../appconfig/AppHelper';
import { ViewDocumentColumns } from '../../../appconfig/DatatableSetting';
import ApprovalModal from '../../../components/Modal/ApprovalModal';
import Loader from '../../../components/Loadeer/Loader';

export const ViewDocument = () => {
    document.title = 'View Document | GSPC';

    const navigate = useNavigate();

    // Parameters
    const { fileNo, appName }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    // File Upload Details
    const fileUploadRef = useRef(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [fileDetails, setFileDetails] = useState<any>([]);
    const [applicationStatus, setApplicationStatus] = useState<any>();
    const [documentsList, setDocumentsList] = useState<any>([]);
    const [tableLoader, setTableLoader] = useState<boolean>(false);
    const [changeStatusModal, setChangeStatusModal] = useState<boolean>(false);
    const [submitAppModal, setSubmitAppModal] = useState<boolean>(false);
    const [submitAppLoader, setSubmitAppLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getFileDetails();
        getAllDocument();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get file details
    const getFileDetails = async () => {
        try {
            setLoading(true);
            const response = await getAllDetails(FILEDETAIL + '?fileNo=' + atob(fileNo) + '&AppName=' + atob(appName));
            if (response) {
                setFileDetails(response);
                // Application Status
                let applicationBadgeInfo = setAppStatus(response.appStatus);
                setApplicationStatus(applicationBadgeInfo);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);

            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all document
    const getAllDocument = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(DOCUMENTLIST + '?fileNo=' + atob(fileNo) + '&AppName=' + atob(appName) + '&parent_id=' + atob(fileNo));
            if (response) {
                setDocumentsList(response?.documents);
                setPageLoad(true);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open change status modal
    const openChangeStatusModal = () => {
        setChangeStatusModal(true);
    };

    // Close change status modal
    const closeChangeStatusModal = () => {
        setChangeStatusModal(false);
    };

    // Template for view
    const viewTemplate = (rowData: any) => {
        return (
            <div>
                <Button icon="pi pi-eye" onClick={() => window.open(rowData?.image_url)} disabled={!window.cn(rowData?.image_url) ? false : true} />
            </div>
        );
    };

    // On file upload
    const onFileUpload = async (e: any, rowData: any) => {
        let fileSize = e.files[0].size / 1024 / 1024;
        if (fileSize > 2) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please upload file size less than 2mb'
            });
        } else {
            setTableLoader(true);
            // setPageLoad(false);

            //Request object
            let formData: any = new FormData();
            formData.append('file', e.files[0]);
            formData.append('document_id', rowData.docId);
            formData.append('fileNo', atob(fileNo));
            formData.append('parent_id', atob(fileNo));
            formData.append('applicationTypeName', atob(appName));

            //apicall
            const response = await postAllData(UPLOADDOCUMENT, formData);
            if (response && !window.cn(response)) {
                setTableLoader(false);
                // setPageLoad(true);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    getAllDocument();
                }, 1500);
            }
        }
    };

    // On verify document
    const onVerifyDocument = async (verified: any, userDocId: any) => {
        let isVerified = verified === true ? 1 : 0;
        setTableLoader(true);

        const response = await getAllDetails(VERIFYDOCUMENT + '?fileNo=' + atob(fileNo) + '&userDocId=' + userDocId + '&isVerified=' + isVerified);
        if (response) {
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document Status Changed' });
            setTableLoader(false);
            setTimeout(() => {
                getAllDocument();
            }, 1500);
        }
    };

    // Template for upload
    const uploadTemplate = (rowData: any) => {
        return (
            <>
                <FileUpload ref={fileUploadRef} accept="application/pdf" name="file[]" mode="basic" onSelect={(e) => onFileUpload(e, rowData)} disabled={applicationStatus?.value === 'Approved' ? true : false}></FileUpload>
            </>
        );
    };

    // Template for document name
    const docNameTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.DocName} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">
                        {' '}
                        {rowData?.DocName} {rowData?.is_required === true && <span style={{ color: 'red' }}>*</span>}
                    </div>
                </Button>
            </>
        );
    };

    // Tempalate fot uploded by
    const uploadedByTemplate = (rowData: any) => {
        return <>{rowData?.uploaded_status === 1 ? <Badge value="System" severity="success"></Badge> : <Badge value="User" severity="warning"></Badge>}</>;
    };

    // Template for verification
    const verificationTemplate = (rowData: any) => {
        return (
            <>
                <InputSwitch
                    checked={rowData?.isVerified == '1' ? true : false}
                    onChange={(e) => onVerifyDocument(e.value, rowData?.userDocId)}
                    disabled={!window.cn(rowData?.image_url) && applicationStatus?.value !== 'Approved' ? false : true}
                    defaultChecked={rowData.isVerified == '1' ? true : false}
                />
            </>
        );
    };

    // Open submit app modal
    const openSubmitAppModal = () => {
        setSubmitAppModal(true);
    };

    // Close submit app modal
    const closeSubmitAppModal = () => {
        setSubmitAppLoader(false);
        setSubmitAppModal(false);
    };

    // On submit application
    const onSubmitApplication = async () => {
        try {
            setSubmitAppLoader(true);
            const response = await getAllDetails(APPROVEFRSHALLAPP + '?SrNo=' + fileDetails?.SrNo + '&verified_by=' + localStorage.getItem('name'));
            if (response) {
                setSubmitAppLoader(false);
                setSubmitAppModal(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Message',
                    detail: response
                });

                setTimeout(() => {
                    if (atob(appName) === 'Fresh Registration') {
                        navigate('/app/application/fresh-registration-list');
                    } else if (atob(appName) === 'Fresh Registration Other State') {
                        navigate('/app/application/fresh-registration-other-list');
                    } else if (atob(appName) === 'Transfer In') {
                        navigate('/app/application/fresh-registration-transfer-list');
                    }
                }, 1500);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Applications'} pageName={'View Document'} pageTitle={'View Document'} goToPage={true} />

            <div className="card">
                <div className="grid">
                    <div className="field col-12 md:col-6  grid flex-column mb-0">
                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Full Name</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">
                                {!window.cn(fileDetails?.StudL) && fileDetails?.StudL} {!window.cn(fileDetails?.StudF) && fileDetails?.StudF} {!window.cn(fileDetails?.StudM) && fileDetails?.StudM}
                            </div>
                        </div>

                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>File No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{fileDetails?.SrNo}</div>
                        </div>

                        <div className="field col-12 grid mb-0">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Status</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{!window.cn(applicationStatus?.severity) && <Badge severity={applicationStatus?.severity} value={applicationStatus?.value}></Badge>}</div>
                        </div>

                        {applicationStatus?.value === 'Hold' && (
                            <div className="field col-12 grid mt-3 mb-0">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Reason</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-7 mb-0">{!window.cn(fileDetails?.comment) ? fileDetails?.comment : '-'}</div>
                            </div>
                        )}

                        {!window.cn(applicationStatus) && applicationStatus?.value === 'Documents : Reuploaded' && (
                            <div className="field col-12 grid mb-0 mt-3 ">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Re-Uploaded Documents</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-9 mb-0">{fileDetails?.unverified_doc}</div>
                            </div>
                        )}
                    </div>

                    <div className="field col-12 md:col-6 grid flex-column align-items-end mb-0">
                        <div className="field col-12 grid mb-3 justify-content-end">
                            <div className="field col-12 md:col-3 mb-0 ">
                                <b>Application Date</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{formatDateTime(fileDetails?.EntDt)}</div>
                        </div>

                        {!window.cn(fileDetails?.RegNo) && (
                            <div className="field col-12 grid mb-3 justify-content-end">
                                <div className="field col-12 md:col-3 mb-0">
                                    <b>Reg No</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{fileDetails?.RegNo}</div>
                            </div>
                        )}

                        <div className="field col-12 grid mb-3 justify-content-end mb-0">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Mobile No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end">{fileDetails?.PPhone}</div>
                        </div>

                        <div className="field col-12 grid mb-0 justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>DOB</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0 grid justify-content-end"> {formatDateTime(fileDetails?.BOD)}</div>
                        </div>
                    </div>
                </div>

                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable value={documentsList} loading={tableLoader} showGridlines stripedRows rows={defaultRowOptions} className="datatable-responsive view-document mt-3" emptyMessage="No Document Found">
                            {ViewDocumentColumns.map((col, i) => {
                                if (col.field === 'view') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={viewTemplate} />;
                                } else if (col.field === 'doc_name') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={docNameTemplate} style={{ maxWidth: '16rem' }} />;
                                } else if (col.field === 'uploaded_by') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={uploadedByTemplate} style={{ minWidth: '5rem' }} />;
                                } else if (col.field === 'upload') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={uploadTemplate} />;
                                } else if (col.field === 'verification') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationTemplate} />;
                                } else if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems} className="mt-3">
                            {ViewDocumentColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}

                <div className="formgrid grid mt-3">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button className="p-button-secondary mr-2" icon="fas fa-edit" label="Change Status" onClick={openChangeStatusModal} disabled={applicationStatus?.value === 'Approved' ? true : false} />
                            <Button label="Submit" icon="pi pi-check" onClick={() => openSubmitAppModal()} loading={false} disabled={applicationStatus?.value === 'Approved' ? true : false} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Change Status Modal */}
            <ApprovalModal
                id={fileDetails?.SrNo}
                appName={
                    atob(appName) === 'fresh-registration'
                        ? 'Fresh Registration'
                        : atob(appName) === 'fresh-registration-other-state'
                        ? 'Fresh Registration Other State'
                        : atob(appName) === 'transfer-territory'
                        ? 'Transfer DD/DNH'
                        : atob(appName) === 'transfer-in'
                        ? 'Transfer In Gujarat'
                        : atob(appName)
                }
                visible={changeStatusModal}
                close={() => closeChangeStatusModal()}
                applicationName={atob(appName)}
                docList={documentsList}
            />

            {/* Submit Application Dialog */}
            <Dialog
                visible={submitAppModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header={'Approve Application'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeSubmitAppModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitApplication()} loading={submitAppLoader} />
                    </>
                }
                onHide={closeSubmitAppModal}
            >
                <h5>Are you sure you want to submit this Application?</h5>
            </Dialog>

            {loading && <Loader />}
        </>
    );
};
